import React from 'react';

//SVG COMPONENTS - loaded with @svgr/webpack
import ArrowButton from '../../../../../img/icon-btn-arrow-right.svg';
import IconCourseMetaCredits from '../../../../../img/icon-course-meta-credits.svg';
import IconCourseMetaBook from '../../../../../img/icon-course-meta-book.svg';
import IconCourseMetaPrice from '../../../../../img/icon-course-meta-price.svg';
import IconCourseMetaLanguage from '../../../../../img/icon-course-meta-language.svg';

/**
 * A component that displays course meta information.
 *
 * @component
 * @param {object} courseDetails - The details of the course
 * @returns {React.ReactElement} The course meta information component
 */
const CourseMetaInfo = ({courseDetails}) => {

    // currency formatter
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 2,
    });

    return (
    <div className="course-details-meta-info">
        <div className="container">
            <div className="icon-metainfo-block">
                <IconCourseMetaCredits />
                <div>
                    <h3 className="headline-label">CE Credits</h3>
                    {courseDetails.ceCredits}
                </div>
            </div>

            <div className="icon-metainfo-block">
                <IconCourseMetaBook />
                <div>
                    <h3 className="headline-label">AGD Credit Allocation</h3>
                    {courseDetails.agdCreditAllocation}
                </div>
            </div>

            <div className="icon-metainfo-block">
                <IconCourseMetaPrice />
                <div>
                    <h3 className="headline-label">Course Price</h3>
                    {formatter.format(Number(courseDetails.coursePrice))}
                </div>
            </div>

            <div className="icon-metainfo-block">
                <IconCourseMetaLanguage />
                <div>
                    <h3 className="headline-label">Languages Offered</h3>
                    {courseDetails.languages}
                </div>
            </div>
        </div>
    </div>
    );
};

export default CourseMetaInfo;